import { render, staticRenderFns } from "./ServicesTabCategories.vue?vue&type=template&id=5cf3f5d6&scoped=true&"
import script from "./ServicesTabCategories.vue?vue&type=script&lang=js&"
export * from "./ServicesTabCategories.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTabCategories.vue?vue&type=style&index=0&id=5cf3f5d6&lang=scss&scoped=true&"
import style1 from "./ServicesTabCategories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3f5d6",
  null
  
)

export default component.exports